const items = [
  { rank: 1, title: '某千万粉网红被曝私下辱骂助理，录音曝光引发行业震动', heat: '🔥 98.7万热度', tag: '人设崩塌', time: '2小时前' },
  { rank: 2, title: '两大顶流网红直播连麦互撕，三小时对线创平台同时在线纪录', heat: '🔥 86.3万热度', tag: '直播争议', time: '5小时前' },
  { rank: 3, title: '知名美食博主带货翻车，质量问题遭消费者集体实名举报', heat: '🔥 72.1万热度', tag: '带货翻车', time: '8小时前' },
  { rank: 4, title: '网红情侣三年感情破裂，分手内幕聊天记录被曝光', heat: '🔥 65.4万热度', tag: '恋情曝光', time: '12小时前' },
  { rank: 5, title: '头部主播涉嫌虚假宣传，监管部门正式介入调查并约谈平台', heat: '🔥 58.9万热度', tag: '监管介入', time: '1天前' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热度榜单</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">实时更新</span>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <a
              key={item.rank}
              href={`#carousel`}
              className="flex items-start gap-3 md:gap-4 p-4 bg-background-50 rounded-lg border border-secondary-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all cursor-pointer group"
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-lg flex items-center justify-center font-heading font-bold text-sm ${
                i === 0 ? 'bg-primary-500 text-background-50' :
                i === 1 ? 'bg-primary-400 text-background-50' :
                i === 2 ? 'bg-accent-500 text-background-50' :
                'bg-secondary-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">{item.title}</h3>
              </div>
              <span className="flex-shrink-0 text-xs md:text-sm font-medium text-accent-600 whitespace-nowrap mt-1">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}